import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ISubjectFrontEndModel } from "../types";
import Button from "../../../components/Button";

const useStyles = makeStyles(() => ({
  subjectCardContainer: {
    height: "100%",
    borderRadius: 16,
    boxShadow: "0 0 4px 0 #c2c9d6",
    padding: 30,
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  iconNameContainer: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontWeight: 500,
    lineHeight: 1.33,
    color: "#231f20",
    fontSize: "1.25rem",
  },
  iconContainer: {
    borderRadius: 10,
    backgroundColor: "#eeeeed",
    padding: "0.625rem",
    marginRight: "1.875rem",
  },
  icon: {
    verticalAlign: "middle",
    borderStyle: "none",
  },
  button: {
    minWidth: 220,
  },
}));

interface ISubjectCardProps {
  subject: ISubjectFrontEndModel;
  onChooseTeacher: () => void;
}

export const SubjectCard: FC<ISubjectCardProps> = ({
  subject,
  onChooseTeacher,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.subjectCardContainer}>
      <div className={classes.iconNameContainer}>
        <div className={classes.iconContainer}>
          <img
            alt="logo"
            className={classes.icon}
            src={subject.icon}
            width={50}
          />
        </div>
        <p className={classes.name}>{subject.name}</p>
      </div>
      <Button
        variant={"contained"}
        color={"secondary"}
        className={classes.button}
        onClick={onChooseTeacher}
      >
        Choose your teacher
      </Button>
    </div>
  );
};
